export default "__VITE_ASSET__Cf4NI5Qp__"